import React from 'react';
import { whyNurse, images } from '../data/mock';
import { Star, Users, MapPin, RefreshCw, Heart } from 'lucide-react';

const iconMap = {
  0: Users,
  1: MapPin,
  2: RefreshCw,
  3: Heart
};

const WhyNurseSection = () => {
  return (
    <section id="why-nurse" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-fuchsia-500 font-semibold text-sm uppercase tracking-wide">
            The Difference
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mt-2 mb-4">
            Care Centered on the <span className="text-nursebloc-gradient">Caregiver and Their Loved One</span>
          </h2>
          <div className="max-w-4xl mx-auto">
            <p className="text-lg text-gray-600 mb-4">
              Many care coordination services are shaped around insurance rules, eligibility periods, or specific diagnoses. Support often ends when coverage changes — even though the caregiver and their loved one are still navigating daily care.
            </p>
            <p className="text-lg font-bold text-slate-700">
              NurseBloc is built around the care pair: the person giving care and the person receiving it.
            </p>
          </div>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Content side */}
          <div>
            <p className="text-lg text-gray-600 mb-8">
              Nurses bring a unique combination of clinical knowledge, system expertise, 
              and genuine compassion. We've spent our careers caring for patients and families 
              like yours.
            </p>

            <div className="space-y-6">
              {whyNurse.map((item, index) => {
                const Icon = iconMap[index];
                return (
                  <div 
                    key={index}
                    className="flex items-start gap-4"
                  >
                    <div className="w-12 h-12 bg-violet-100 rounded-xl flex items-center justify-center flex-shrink-0">
                      <Icon className="w-6 h-6 text-violet-600" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-slate-800 mb-1">
                        {item.title}
                      </h3>
                      <p className="text-gray-600 leading-relaxed">
                        {item.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Image side */}
          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-xl">
              <img 
                src={images.patientAdvocacy}
                alt="Nurse providing patient advocacy and medication guidance"
                className="w-full h-[400px] md:h-[500px] object-cover"
              />
            </div>
            
            {/* Quote card */}
            <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl p-6 shadow-xl border border-violet-100 max-w-[300px]">
              <svg className="w-8 h-8 text-fuchsia-400 mb-2" fill="currentColor" viewBox="0 0 24 24">
                <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z"/>
              </svg>
              <p className="text-slate-700 italic">
                "Because good care supports the whole relationship — not just the system around it."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyNurseSection;
